
function requestAPI(id, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}transaction/finish/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionFInishTransaction(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'FINISH_TRANSACTION_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(id, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'FINISH_TRANSACTION_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'FINISH_TRANSACTION_FAILURE',        
    error: error    
  })
}